module.exports = __webpack_public_path__ + "cdd11a0d4543ee13736fb3027a7e2896.pdf";